import { Group } from "three";
import { CSS2DObject } from "three/examples/jsm/renderers/CSS2DRenderer.js";

import type { FigureData } from "../data/octagonOnCube";

const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

/**
 * 各頂点に CSS2DObject でアルファベットラベルを配置する。
 * 頂点は 3D 座標で扱い、CSS2D が画面投影してくれるので OrbitControls で
 * 回転させてもラベルは追従する（ただし文字自体は画面に対して水平のまま）。
 */
export class Labels {
  readonly group: Group;
  private readonly elements: HTMLDivElement[];

  constructor(data: FigureData) {
    this.group = new Group();
    this.elements = [];
    for (let i = 0; i < data.vertices.length; i++) {
      const [x, y, z] = data.vertices[i];
      const el = document.createElement("div");
      el.className = "vertex-label";
      el.textContent = ALPHABET[i] ?? `V${i}`;
      const label = new CSS2DObject(el);
      label.position.set(x, y, z);
      label.center.set(0, 0.5);
      this.group.add(label);
      this.elements.push(el);
    }
  }

  setVisible(visible: boolean): void {
    this.group.visible = visible;
  }

  /** 各ラベルの 3D 位置を差し替える (八角形比率の切替用)。 */
  setPositions(vertices: [number, number, number][]): void {
    const children = this.group.children;
    for (let i = 0; i < children.length && i < vertices.length; i++) {
      children[i].position.set(
        vertices[i][0],
        vertices[i][1],
        vertices[i][2],
      );
    }
  }

  setOpacity(i: number, value: number): void {
    const el = this.elements[i];
    if (el) el.style.opacity = String(value);
  }
}
